import type { ReactElement, ReactNode } from "react"
import { useTranslation } from "react-i18next"

import { DialogWindow, DialogWindowFooter, DialogWindowHeader } from ".."
import { Body1 } from "../../atoms"

import "./confirmation-dialog.styles.scss"

export interface IConfirmationDialogProps {
  open: boolean
  title: string
  className?: string
  confirmText: string
  bodyText: ReactNode
  onCancel: () => void
  onConfirm: () => void
}

export function ConfirmationDialog(props: IConfirmationDialogProps): ReactElement {
  const { open, title, className, confirmText, bodyText, onCancel, onConfirm } = props

  const { t } = useTranslation("general")

  return (
    <DialogWindow className={`confirmation-dialog ${className ? className : ""}`} open={open} onClose={onCancel}>
      <DialogWindowHeader onClose={onCancel} title={title} />
      <Body1 className="confirm-body">{bodyText}</Body1>
      <DialogWindowFooter
        onCancel={onCancel}
        onConfirm={onConfirm}
        confirmText={confirmText}
        cancelText={t("dialog.cancel")}
      />
    </DialogWindow>
  )
}
